module.exports = __webpack_public_path__ + "static/images/step5.7f79efd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/step/step5.png
// module id = XIM/
// module chunks = 1